<p-floatLabel>
  <p-select #serviceConfigurationStateDropdown
            id="serviceConfigurationDropdown"
            name="serviceConfigurationDropdown"
            [options]="serviceConfigurationStates"
            [(ngModel)]="serviceConfigurationState"
            [showClear]="!isRequired"
            [checkmark]="true"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="serviceConfigurationDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>